var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83194 4.25674C7.52559 4.71627 6.90472 4.84044 6.44519 4.53409L3.99989 2.90389L1.55459 4.53409C1.09507 4.84044 0.474196 4.71627 0.167843 4.25674C-0.13851 3.79721 -0.0143356 3.17634 0.445193 2.86999L3.99989 0.500192L7.55459 2.86999C8.01412 3.17634 8.1383 3.79721 7.83194 4.25674Z",
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronPrimary);
export default __webpack_public_path__ + "static/media/chevron-primary.4608f3899504cdda744c0e549f913a39.svg";
export { ForwardRef as ReactComponent };